import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  constructor(
    private _http: HttpClient
  ) { }

  getAllOrganizations() {
    return this._http.get(`${environment.url}/organization`)
  }
}
